import React, { useEffect, useState, lazy, Suspense } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useNavigate,
  useLocation,
} from "react-router-dom";
import { UserProvider, useUser } from "./context/UserContext";
import "./App.scss";
//screens
import Login from "./screens/Global/Login/Login";
import Productos from "./screens/Cliente/Home/Productos";
import Producto from "./screens/Cliente/ProductoDetalles/Producto";
import Carrito from "./screens/Cliente/Cart/CartView";
import BuscadorProductos from "./screens/Cliente/Buscador/BuscadorProductos";
import ClienteView from "./layouts/Cliente/ClienteView";
import Servicio from "./screens/Cliente/ServicioDetalles/Servicio";
import { ConfigProvider, Spin, message } from "antd";
import { estadoVendedor } from "./utils/vendedor/estadoVendedor";
import locale from "antd/es/locale/es_ES";
import ClienteViewNavSinBuscador from "./layouts/Cliente/ClienteViewNavSinBuscador";
import { getFirestore, doc, getDoc } from "firebase/firestore";
import DownloadAppPrompt from "./components/DownloadAppPrompt/DownloadAppPrompt";
import BlizuLoader from "./components/BlizuLoader/BlizuLoader";
import { MODERACION_ACTIVA } from "./config";

// Pantallas cargadas bajo demanda (cada una se descarga solo al visitarla)
const Registro = lazy(() => import("./screens/Cliente/RegistroCliente/RegistroAdmin"));
const RegistroVendedor = lazy(() => import("./screens/Vendedor/RegistroVendedor/RegistroVendedor"));
const Perfil = lazy(() => import("./screens/Cliente/Perfil/Perfil"));
const Pedidos = lazy(() => import("./screens/Cliente/Pedidos/Pedidos"));
const Tipo = lazy(() => import("./screens/Global/Tipo/Tipo"));
const CrearTienda = lazy(() => import("./screens/Vendedor/CreateTienda/CrearTienda"));
const EditarTienda = lazy(() => import("./screens/Vendedor/EditarTienda/EditarTienda"));
const MisProductos = lazy(() => import("./screens/Vendedor/MisProductos/MisProductos"));
const CrearProducto = lazy(() => import("./screens/Vendedor/CrearProducto/CrearProducto"));
const EditarProducto = lazy(() => import("./screens/Vendedor/EditarProducto/EditarProducto"));
const Favoritos = lazy(() => import("./screens/Cliente/Favoritos/Favoritos"));
const TerminosCondiciones = lazy(() => import("./screens/Global/InformacionPagina/TerminosCondiciones/TerminosCondiciones"));
const DeclaracionPrivacidad = lazy(() => import("./screens/Global/InformacionPagina/DeclaracionPrivacidad/DeclaracionPrivacidad"));
const TerminosMarketplace = lazy(() => import("./screens/Global/InformacionPagina/TerminosMarketplace/TerminosMarketplace"));
const Cards = lazy(() => import("./screens/Cliente/Cards/Cards"));
const CrearServicio = lazy(() => import("./screens/Vendedor/CrearServicio/CrearServicio"));
const EstadisticasVendedor = lazy(() => import("./screens/Vendedor/EstadisticasVendedor/EstadisticasVendedor"));
const CategoriasAdmin = lazy(() => import("./screens/Admin/Categorias/CategoriasAdmin"));
const ComisionesAdmin = lazy(() => import("./screens/Admin/Comisiones/ComisionesAdmin"));
const VendedoresAdmin = lazy(() => import("./screens/Admin/Vendedores/VendedoresAdmin"));
const TiendasAdmin = lazy(() => import("./screens/Admin/Tiendas/TiendasAdmin"));
const CategoriasTipo = lazy(() => import("./screens/Admin/Categorias/CategoriaTipo"));
const UsuariosAdmin = lazy(() => import("./screens/Admin/Usuario/UsuariosAdmin"));
const EditarPerfil = lazy(() => import("./screens/Cliente/EditarPerfil/EditarPerfil"));
const DireccionesCliente = lazy(() => import("./screens/Cliente/Direcciones/DireccionesCliente"));
const MisServicios = lazy(() => import("./screens/Vendedor/MisServicios/MisServicios"));
const EditarServicio = lazy(() => import("./screens/Vendedor/EditarServicio/EditarServicio"));
const AdminsAdmin = lazy(() => import("./screens/Admin/Admins/AdminsAdmin"));
const EditarAdmin = lazy(() => import("./screens/Admin/Admins/EditarAdmin"));
const RegistroAdmin = lazy(() => import("./screens/Admin/RegistroAdmin/Registro"));
const CarruselImagenes = lazy(() => import("./screens/Admin/CarruselAdmin/CarruselImagenes"));
const ConvertirseVendedor = lazy(() => import("./screens/Cliente/ConvertirseVendedor/ConvertirseVendedor"));
const DashboardVendedor = lazy(() => import("./layouts/DashboardVendedor/DashboardVendedor"));
const DashboardAdmin = lazy(() => import("./layouts/DashboardAdmin/DashboardAdmin"));
const ForgotPassword = lazy(() => import("./screens/Global/OlvideContra/ForgotPassword"));
const Checkout = lazy(() => import("./screens/Cliente/Checkout/Checkout"));
const Chat = lazy(() => import("./screens/Cliente/Chat/Chat"));
const DetallesPedidoCliente = lazy(() => import("./screens/Cliente/PedidoDetalles/DetallesPedidoCliente"));
const EstadisticasAdmin = lazy(() => import("./screens/Admin/Dashboard/EstadisticasAdmin"));
const PedidosAdmin = lazy(() => import("./screens/Admin/Pedidos/PedidosAdmin"));
const DetallePedidoAdmin = lazy(() => import("./screens/Admin/Pedidos/DetallePedidoAdmin"));
const UsuariosVendedorAdmin = lazy(() => import("./screens/Admin/UsuarioVendedor/UsuariosVendedorAdmin"));
const SubpedidosVendedor = lazy(() => import("./screens/Vendedor/SubpedidosVendedor/SubpedidosVendedor"));
const DetalleSubpedidosVendedor = lazy(() => import("./screens/Vendedor/DetalleSubpedidosVendedor/DetalleSubpedidosVendedor"));
const PagoAVendedores = lazy(() => import("./screens/Admin/PagoAVendedores/PagoAVendedores"));
const ReseñasVendedor = lazy(() => import("./screens/Cliente/VendedorReseñas/ReseñasVendedor"));
const DatosDePagoAVendedor = lazy(() => import("./screens/Vendedor/DatosPago/DatosDePagoAVendedor"));
const AdminAprobarDatosPago = lazy(() => import("./screens/Admin/AprobarDatosPago/AdminAprobarDatosPago"));
const VendedorChat = lazy(() => import("./screens/Vendedor/Chat/VendedorChat"));
const AdminChatApproval = lazy(() => import("./screens/Admin/AdminChat/AdminChatApproval"));
const PendingMessagesView = lazy(() => import("./screens/Admin/MensajesPendientes/PendingMessagesView"));
const PreguntasAdmin = lazy(() => import("./screens/Admin/PreguntasAdmin/PreguntasAdmin"));
const ReportesAdmin = lazy(() => import("./screens/Admin/ReportesAdmin/ReportesAdmin"));
const DisputasAdmin = lazy(() => import("./screens/Admin/Disputas/DisputasAdmin"));
const BitacoraAdmin = lazy(() => import("./screens/Admin/Bitacora/BitacoraAdmin"));
const DisputaDetalle = lazy(() => import("./screens/Cliente/Disputas/DisputaDetalle"));
const MisDisputas = lazy(() => import("./screens/Cliente/Disputas/MisDisputas"));
const Notificaciones = lazy(() => import("./screens/Global/Notificaciones/Notificaciones"));
const ReenviarVerificacion = lazy(() => import("./screens/Vendedor/ReenviarVerificacion/ReenviarVerificacion"));
const CalendarioVendedor = lazy(() => import("./screens/Vendedor/Calendario/CalendarioVendedor"));
const EliminarCuenta = lazy(() => import("./screens/Global/InformacionPagina/EliminarCuenta/EliminarCuenta"));

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
    const containers = document.querySelectorAll("[data-scroll-container]");
    containers.forEach((el) => {
      el.scrollTo({ top: 0, left: 0, behavior: "auto" });
    });
  }, [pathname]);
  return null;
}

const PrivateRoute = ({ element, requiredRole }) => {
  const { userData, userDataAvailable } = useUser();
  const navigate = useNavigate();
  const db = getFirestore();
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    let isMounted = true;

    const checkStoreExistence = async (userId) => {
      if (!userId) return false;
      try {
        const storeDocRef = doc(db, `tiendas/${userId}`);
        const storeDoc = await getDoc(storeDocRef);
        return storeDoc.exists();
      } catch (error) {
        console.error("Error checking store existence:", error);
        return false;
      }
    };

    const validateAccess = async () => {
      // Mientras la sesión se esté verificando en Firebase, esperamos
      if (userDataAvailable === null) return;

      if (userDataAvailable && userData) {
        // 1. Rol insuficiente
        if (![0, 1, 2].includes(userData.role) || userData.role < requiredRole) {
          navigate("/");
          return;
        }

        // 2. Admin intentando entrar a ruta de vendedor
        if (userData.role === 2 && requiredRole === 1) {
          navigate("/");
          return;
        }

        // 3. Vendedor entrando al Dashboard de vendedor
        if (userData.role === 1 && requiredRole === 1) {
          // Cuenta en revisión o bloqueada: no entra al panel aunque ya tenga tienda
          if (!userData.activado) {
            const estado = estadoVendedor(userData);
            message[estado.nivel === "error" ? "error" : "warning"]({
              key: "panel-vendedor-bloqueado",
              duration: 7,
              content: `${estado.titulo}. ${estado.descripcion}`,
            });
            navigate(estado.enlace || "/");
            return;
          }

          const storeExists = await checkStoreExistence(userData.uid);
          if (!isMounted) return;

          if (storeExists) {
            // El vendedor ya tiene tienda registrada y activa
            setChecking(false);
            return;
          }

          // Aprobado pero aún sin tienda
          if (window.location.pathname.startsWith("/creartienda")) {
            // Ya está en la pantalla de crear tienda: mostrarla en lugar de redirigir a la misma ruta
            setChecking(false);
            return;
          } else {
            navigate("/creartienda");
            return;
          }
        }

        if (isMounted) setChecking(false);
      } else if (userDataAvailable === false) {
        navigate("/");
      }
    };

    validateAccess();

    return () => {
      isMounted = false;
    };
  }, [userData, userDataAvailable, requiredRole, navigate, db]);

  if (userDataAvailable === null || checking) {
    return (
      <BlizuLoader message="Verificando acceso a tu cuenta..." fullScreen />
    );
  }

  return element;
};

export default function App() {
  return (
    <Router>
      <ScrollToTop />
      <ConfigProvider locale={locale}>
        <UserProvider>
          {/* ---> AQUÍ AGREGAMOS LA PRUEBA PARA QUE SE EJECUTE SIEMPRE <--- */}
          <DownloadAppPrompt />
          <Suspense fallback={<BlizuLoader message="Cargando Blizu..." fullScreen />}>
          <Routes basename="/">
            <Route path="/" element={<ClienteView />}>
              <Route path="" element={<Productos />} />
              <Route path="/producto/:id" element={<Producto />} />
              <Route path="/servicio/:id" element={<Servicio />} />
              <Route path="/buscador" element={<BuscadorProductos />} />
              <Route
                path="/reseñas/:vendedorUid"
                element={<ReseñasVendedor />}
              />
            </Route>

            <Route path="/" element={<ClienteViewNavSinBuscador />}>
              <Route
                path="/terminos-condiciones"
                element={<TerminosCondiciones />}
              />
              <Route
                path="/eliminar-cuenta"
                element={<EliminarCuenta />}
              />
              <Route
                path="/declaracion-privacidad"
                element={<DeclaracionPrivacidad />}
              />
              <Route
                path="/terminos-vendedor"
                element={<TerminosMarketplace />}
              />
            </Route>
            {/*Navegación cliente*/}
             <Route
               path="/"
               element={<ClienteView />}
             >
               <Route path="/perfil" element={<PrivateRoute element={<Perfil />} requiredRole={0} />} />
               <Route path="/perfil/editar" element={<PrivateRoute element={<EditarPerfil />} requiredRole={0} />} />
               <Route path="/perfil/convertirse-vendedor" element={<PrivateRoute element={<ConvertirseVendedor />} requiredRole={0} />} />
               <Route
                 path="/perfil/direcciones"
                 element={<PrivateRoute element={<DireccionesCliente />} requiredRole={0} />}
               />
               <Route path="/mistarjetas" element={<PrivateRoute element={<Cards />} requiredRole={0} />} />
               <Route path="/carrito" element={<Carrito />} />
               <Route path="/pedidos" element={<PrivateRoute element={<Pedidos />} requiredRole={0} />} />
               <Route path="/pedido/:id" element={<PrivateRoute element={<DetallesPedidoCliente />} requiredRole={0} />} />
               <Route path="/favoritos" element={<Favoritos />} />
               <Route path="/chat/:subpedidoId" element={<PrivateRoute element={<Chat />} requiredRole={0} />} />
               <Route path="/notificaciones" element={<PrivateRoute element={<Notificaciones />} requiredRole={0} />} />
               {MODERACION_ACTIVA && <Route path="/disputas" element={<PrivateRoute element={<MisDisputas />} requiredRole={0} />} />}
               {MODERACION_ACTIVA && <Route path="/disputa/:id" element={<PrivateRoute element={<DisputaDetalle />} requiredRole={0} />} />}
               <Route path="/perfil/verificacion" element={<PrivateRoute element={<ReenviarVerificacion />} requiredRole={0} />} />
             </Route>

            <Route
              path="/"
              element={
                <PrivateRoute
                  element={<ClienteViewNavSinBuscador />}
                  requiredRole={0}
                />
              }
            >
              <Route path="/checkout" element={<Checkout />} />
            </Route>
            {/*Navegación vista vendedor */}
            <Route
              path="/creartienda"
              element={
                <PrivateRoute element={<CrearTienda />} requiredRole={1} />
              }
            />

            <Route
              path="/dashboard"
              element={
                <PrivateRoute
                  element={<DashboardVendedor />}
                  requiredRole={1}
                />
              }
            >
              <Route
                path="/dashboard/tienda/editar"
                element={<EditarTienda />}
              />
              <Route
                path="/dashboard/misproductos"
                element={<MisProductos />}
              />
              <Route
                path="/dashboard/editarproducto/:id"
                element={<EditarProducto />}
              />
              <Route
                path="/dashboard/crearproducto"
                element={<CrearProducto />}
              />
              <Route
                path="/dashboard/misservicios"
                element={<MisServicios />}
              />
              <Route
                path="/dashboard/crearservicio"
                element={<CrearServicio />}
              />
              <Route
                path="/dashboard/mispedidos"
                element={<SubpedidosVendedor />}
              />
              <Route
                path="/dashboard/mispedidos/subpedidos/:id"
                element={<DetalleSubpedidosVendedor />}
              />
              <Route
                path="/dashboard/editarservicio/:id"
                element={<EditarServicio />}
              />
              <Route
                path="/dashboard/datosdepago"
                element={<DatosDePagoAVendedor />}
              />
               <Route
                 path="/dashboard/chat/:subpedidoId"
                 element={<VendedorChat />}
               />
               <Route path="/dashboard/calendario" element={<CalendarioVendedor />} />
               <Route path="/dashboard/notificaciones" element={<Notificaciones />} />
               {MODERACION_ACTIVA && <Route path="/dashboard/disputas" element={<MisDisputas />} />}
               {MODERACION_ACTIVA && <Route path="/dashboard/disputa/:id" element={<DisputaDetalle />} />}
               {MODERACION_ACTIVA && <Route path="/dashboard/disputas/:id" element={<DisputaDetalle />} />}
               <Route path="/dashboard/" element={<EstadisticasVendedor />} />
            </Route>
            <Route
              path="/admin"
              element={
                <PrivateRoute element={<DashboardAdmin />} requiredRole={2} />
              }
            >
              <Route path="carrusel" element={<CarruselImagenes />} />
              <Route path="categorias" element={<CategoriasAdmin />} />
              <Route
                path="categorias/productos"
                element={<CategoriasTipo tipo={"producto"} />}
              />
              <Route
                path="categorias/servicios"
                element={<CategoriasTipo tipo={"servicio"} />}
              />
              <Route path="comisiones" element={<ComisionesAdmin />} />
              <Route
                path="vendedores/pendientes"
                element={<VendedoresAdmin />}
              />
              <Route
                path="vendedores"
                element={<UsuariosVendedorAdmin activado={true} />}
              />
              <Route
                path="pagosavendedores"
                element={<PagoAVendedores />}
              />
              <Route
                path="aprobardatospago"
                element={<AdminAprobarDatosPago />}
              />
              <Route
                path="vendedores/blacklist"
                element={<UsuariosVendedorAdmin activado={false} />}
              />
              <Route
                path="usuarios"
                element={<UsuariosAdmin activado={true} />}
              />
              <Route
                path="usuarios/blacklist"
                element={<UsuariosAdmin activado={false} />}
              />
              <Route
                path="admins"
                element={<AdminsAdmin activado={true} />}
              />
              <Route
                path="admins/blacklist"
                element={<AdminsAdmin activado={false} />}
              />
              <Route path="admins/agregar" element={<RegistroAdmin />} />
              <Route path="admins/editar/:id" element={<EditarAdmin />} />
              <Route path="" element={<EstadisticasAdmin />} />
              <Route path="pedidos" element={<PedidosAdmin />} />
              <Route path="pedido/:id" element={<DetallePedidoAdmin />} />
              <Route path="preguntas" element={<PreguntasAdmin  revisado = {false} />} />
              <Route path="preguntas/respondidas" element={<PreguntasAdmin  revisado ={true} />} />
              {MODERACION_ACTIVA && <Route path="disputas" element={<DisputasAdmin />} />}
              {MODERACION_ACTIVA && <Route path="bitacora" element={<BitacoraAdmin />} />}
              {MODERACION_ACTIVA && <Route path="reportes" element={<ReportesAdmin revisado={false} />} />}
              {MODERACION_ACTIVA && <Route path="reportes/revisados" element={<ReportesAdmin revisado={true} />} />}
              <Route
                path="tiendas"
                element={<TiendasAdmin activado={true} />}
              />
              <Route
                path="tiendas/blacklist"
                element={<TiendasAdmin activado={false} />}
              />
              <Route path="revicionchats" element={<PendingMessagesView />} />
              <Route path="chat/:subpedidoId" element={<AdminChatApproval />} />
            </Route>

            <Route path="/login" element={<Login />} />
            <Route path="/olvide" element={<ForgotPassword />} />
            <Route path="/registrarse/comprador" element={<Registro />} />
            <Route
              path="/registrarse/vendedor"
              element={<RegistroVendedor />}
            />
            <Route path="/tipo" element={<Tipo />} />
          </Routes>
          </Suspense>
        </UserProvider>
      </ConfigProvider>
    </Router>
  );
}
